<template>
  <div class=" is-fullwidth">
    <div class="is-pulled-right">
      <button class="button is-danger" v-if="working==true">Reloading data ...</button>
    </div>
    <div class="buttons">
        <button class="button " v-bind:class="{'is-success': selected_location_id == row.id}" v-for="row in locations" :disabled="loading==true || working==true" :key="row.id" @click="selected_location_id = row.id">{{ row.name }}</button>
    </div>

    <div class="notification is-warning" v-if="loading==true && showError == false">
      <p>Loading data ....</p>
    </div>

    <div class="notification is-danger" v-if="showError == true">
      <p>An error has occurred loading the data</p>
      <p><button class="button is-success" @click="reloadOrders()">Reload Data</button></p>
    </div>

    <div v-if="loading==false">
        
          <div class="column mb-6">
            <h3 class="title is-3">Assigned</h3>
            {{ orders.length }} orders<br />
            {{ assignedOrders.bundles }} bundles<br />
            {{ assignedOrders.garments }} garments

          </div>

          <div class="columns mb-6">

            <div class="column">
              <h3 class="title is-3">Received</h3>
              <progress class="progress is-info" :value="assignedOrders.received_garments" :max="assignedOrders.garments">{{ assignedOrders.received_garments }} garments</progress>
              {{ assignedOrders.received_bundles}} bundles<br />
              {{ assignedOrders.received_garments }} garments

            </div>

            <div class="column">
              <h3 class="title is-3">Not Yet Received</h3>
              <progress class="progress is-danger" :value="assignedOrders.garments-assignedOrders.received_garments" :max="assignedOrders.garments">{{ assignedOrders.garments-assignedOrders.received_garments }} garments</progress>
              {{ assignedOrders.bundles-assignedOrders.received_bundles }} bundles<br />
              {{ assignedOrders.garments-assignedOrders.received_garments }} garments

            </div>
          </div>
          <div class="columns mb-6">

            <div class="column">
              <h3 class="title is-3">On Factory Floor</h3>
              <progress class="progress is-success" :value="assignedOrders.on_floor_garments" :max="assignedOrders.garments">{{ assignedOrders.on_floor_garments }} garments</progress>
              {{ assignedOrders.on_floor_bundles}} bundles<br />
              {{ assignedOrders.on_floor_garments }} garments

            </div>

            <div class="column">
              <h3 class="title is-3">Off Factory Floor</h3>
              <progress class="progress is-success" :value="assignedOrders.off_floor_garments" :max="assignedOrders.garments">{{ assignedOrders.off_floor_garments }} garments</progress>
              {{ assignedOrders.off_floor_bundles}} bundles<br />
              {{ assignedOrders.off_floor_garments }} garments

            </div>

            

        </div>

        <div class="columns">
          <div class="column">
              <h3 class="title is-3">Received and Waiting To Go On Floor</h3>
              <progress class="progress is-warning" :value="assignedOrders.received_garments-assignedOrders.on_floor_garments-assignedOrders.off_floor_garments" :max="assignedOrders.garments">{{ assignedOrders.received_garments -assignedOrders.on_floor_garments -assignedOrders.off_floor_garments}} garments</progress>
              {{ assignedOrders.received_bundles-assignedOrders.on_floor_bundles-assignedOrders.off_floor_bundles}} bundles<br />
              {{ assignedOrders.received_garments-assignedOrders.on_floor_garments-assignedOrders.off_floor_garments }} garments

            </div>

              <div class="column">
                <h3 class="title is-3">Fully Made But Order Not Marked Complete</h3>
                <progress class="progress is-link" :value="assignedOrders.made_up_orders" :max="orders.length">{{ assignedOrders.made_up_orders }} orders</progress>
                {{ assignedOrders.made_up_orders}} order<span v-if="assignedOrders.made_up_orders > 1">s</span><br />
                {{ assignedOrders.made_up_bundles}} bundles<br />
                {{ assignedOrders.made_up_garments }} garments

              </div>

             

          </div>


    </div>
    
    

    

   
    
    
    
  </div>
</template>



<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      locations: [],
      selected_location_id: 0,
      order_by: 'deliverydate ASC',
      search: '',
      limit: '',
      modalOrderPONumber: '',
      modalOrder: {ponumber: '', bundles: []},
      modalOrderLoading: false,
      showError : false,
      accessToken: ''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getMakeupOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
            this.showError = false
          }).bind(this)
        ).catch(error => {
            error => this.status = error.response.data.status;
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);

            this.showError = true
          });
      },

      async reloadOrders() {
        this.working=true
        
        OrderService.getMakeupOrders(this.accessToken, this.selected_location_id, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.working=false
            this.loading=false
            this.showError = false
          }).bind(this)
        ).catch(error => {
            error => this.status = error.response.data.status;
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            this.showError = true
          });
      },
    
    
    async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?makeup=1").then(
               response => this.locations = response 
            );
      },
      async getModalOrder() {
        this.modalOrderLoading=true
          OrderService.getOrderByPONumber(this.accessToken, this.modalOrderPONumber, "")
          .then(
            (orders => {
                if(orders.length > 0)
                {
                      this.$set(this, "modalOrder", orders[0]);
                }
              this.modalOrderLoading=false
            }).bind(this)
          );
      },
      exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Makeup Overview.xlsx')

	 },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            //if(  u.artwork_printed_paper == 0) 
           // {
               console.log(u)
              return 1
           // }
          })

          if(this.search != '' && this.search != null)
          {

            filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.trim().toLowerCase()))
          }

          return filteredOrders
       
     },
     assignedOrders: function () {
        const total = this.filteredOrders.reduce((sum, object) => {
            var num_bundles = object.bundles.length

            var num_garments = object.bundles.reduce((sum2, object2) => {
              sum2.total += object2.qty

              if(object2.received == 1)
              {
                sum2.received_bundles++
                sum2.received_garments += object2.qty
              }

              if(object2.on_factory_floor == 1 && object2.off_factory_floor == 0)
              {
                sum2.on_floor_bundles++
                sum2.on_floor_garments += object2.qty
              }

              if(object2.off_factory_floor == 1 )
              {
                sum2.off_floor_bundles++
                sum2.off_floor_garments += object2.qty
              }

              return sum2
            }, {total: 0, received_garments: 0, received_bundles: 0, on_floor_bundles: 0, on_floor_garments: 0, off_floor_bundles: 0, off_floor_garments: 0});

            

            sum.bundles += num_bundles
            sum.garments += num_garments.total
            sum.received_garments += num_garments.received_garments
            sum.received_bundles += num_garments.received_bundles
            sum.on_floor_garments += num_garments.on_floor_garments
            sum.on_floor_bundles += num_garments.on_floor_bundles
            sum.off_floor_garments += num_garments.off_floor_garments
            sum.off_floor_bundles += num_garments.off_floor_bundles

            if(num_garments.total > 0 && (num_garments.off_floor_garments == num_garments.total) )
            {
              sum.made_up_orders++;
              sum.made_up_bundles = sum.made_up_bundles + num_bundles;
              sum.made_up_garments = sum.made_up_garments + num_garments.total;
            }

          return sum
        }, {bundles:0, garments: 0, received_garments: 0, received_bundles: 0, on_floor_bundles: 0, on_floor_garments: 0, off_floor_bundles: 0, off_floor_garments: 0, made_up_orders: 0, made_up_bundles:0, made_up_garments:0})

        return total
     },
    
     
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
        });
  },
 
  mounted() {
    if (localStorage.makeup_limit) {
      this.limit = localStorage.makeup_limit;
    }
    else{
      this.limit = ''
    }

    if (localStorage.makeup_location_id) {
      this.selected_location_id = localStorage.makeup_location_id;
    }
    else{
      this.selected_location_id = 1
    }

    window.setInterval(() => {
      this.reloadOrders()
    }, 120000)
      
  },
  watch: {
    'selected_location_id'() {
      
      localStorage.makeup_location_id = this.selected_location_id
      if(this.accessToken != '')
      {
        this.orders = []
        this.getOrders();
      }
    },
    'limit'() {
      localStorage.makeup_limit = this.limit

      if(this.accessToken != '')
      {
        this.orders = []
        this.getOrders();
      }
      
    }
    ,
    'modalOrderPONumber'() {
      this.modalOrder = {ponumber:'', bundles: []}
      this.getModalOrder();
    }
  }
}


</script>

